import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import router from './router'
import utils from '@/utils/utils'
import store from './store'
import moment from 'moment'
import 'element-ui/lib/theme-chalk/index.css'
import '@/style/common.css'
import '@/style/reset.css'
import '@/style/toast.css'
import './assets/iconfont/iconfont.css';
import './assets/iconfont/iconfont';
import wps from '@ibsaas/wps-preview'
import { beforeunloadByOverdueTime } from '@/utils/window'
import RdMessageBox from '@/components/messageBox/RdMessageBox';
import MyDirective from '@/directive/index';

Vue.use(ElementUI)
Vue.use(MyDirective);

Vue.config.productionTip = false
Vue.prototype.$moment = moment
Vue.prototype.$utils = utils
Vue.prototype.$wps = wps
Vue.prototype.$bus = new Vue()
Vue.prototype.$RdMessageBox = RdMessageBox;

// 关闭窗口时清除过期缓存数据
window.addEventListener('beforeunload', beforeunloadByOverdueTime())

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js